import { graphql } from '@/gql'

export const CREATE_DOCUMENT = graphql(`
  mutation graphileCreateDocument(
    $filename: String!
    $mimetype: String
    $access: String!
    $fileType: String!
    $fileOwner: StorageFileOwner!
    $fileOwnerId: UUID!
    $documentTypeId: UUID
    $base64: String
    $path: String!
    $fileExtension: String!
    $responsibleUserIdsToAdd: [UUID]
    $responsibleUserIdsToDelete: [UUID]
    $createdAt: Datetime
    $deleteAt: Datetime
    $expireAt: Datetime
    $remindAt: Datetime
    $companyId: UUID
    $html: String
    $documentFolderId: UUID
  ) {
    createStorage(
      input: {
        storage: {
          filename: $filename
          mimetype: $mimetype
          access: $access
          fileType: $fileType
          fileOwner: $fileOwner
          fileOwnerId: $fileOwnerId
          documentTypeId: $documentTypeId
          base64: $base64
          path: $path
          fileExtension: $fileExtension
          createdAt: $createdAt
          deleteAt: $deleteAt
          expireAt: $expireAt
          remindAt: $remindAt
          companyId: $companyId
          responsibleUserIdsToAdd: $responsibleUserIdsToAdd
          responsibleUserIdsToDelete: $responsibleUserIdsToDelete
          html: $html
          documentFolderId: $documentFolderId
        }
      }
    ) {
      storage {
        id
        path
        filename
        fileOwner
        fileOwnerId
        mimetype
        fileExtension
        createdAt
        deleteAt
        expireAt
        remindAt
        html
        documentType {
          id
          name
        }
      }
    }
  }
`)

export const UPDATE_DOCUMENT_TYPE = graphql(`
  mutation updateDocumentType($id: UUID!, $documentTypeId: UUID) {
    updateStorageById(
      input: { id: $id, patch: { documentTypeId: $documentTypeId } }
    ) {
      storage {
        id
        documentType {
          id
          name
        }
      }
    }
  }
`)

export const UPDATE_DOCUMENT = graphql(`
  mutation graphileUpdateDocument(
    $id: UUID!
    $mimetype: String
    $filename: String
    $fileType: String
    $fileOwner: StorageFileOwner
    $fileOwnerId: UUID
    $documentTypeId: UUID
    $base64: String
    $fileExtension: String
    $createdAt: Datetime
    $deleteAt: Datetime
    $expireAt: Datetime
    $remindAt: Datetime
    $responsibleUserIdsToAdd: [UUID]
    $responsibleUserIdsToDelete: [UUID]
    $active: Boolean
    $html: String
    $documentFolderId: UUID
    $path: String
  ) {
    updateStorageById(
      input: {
        id: $id
        patch: {
          filename: $filename
          mimetype: $mimetype
          fileType: $fileType
          fileOwner: $fileOwner
          fileOwnerId: $fileOwnerId
          documentTypeId: $documentTypeId
          base64: $base64
          fileExtension: $fileExtension
          createdAt: $createdAt
          deleteAt: $deleteAt
          expireAt: $expireAt
          remindAt: $remindAt
          active: $active
          responsibleUserIdsToAdd: $responsibleUserIdsToAdd
          responsibleUserIdsToDelete: $responsibleUserIdsToDelete
          html: $html
          documentFolderId: $documentFolderId
          path: $path
        }
      }
    ) {
      storage {
        id
        path
        filename
        fileOwner
        fileOwnerId
        mimetype
        fileExtension
        createdAt
        deleteAt
        expireAt
        remindAt
        html
        documentType {
          id
          name
        }
      }
    }
  }
`)

export const DOCUMENT_TYPE_CREATE = graphql(`
  mutation documentTypeCreate(
    $documentType: String!
    $companyId: UUID!
    $lifetime: Int
    $autoDeleteDays: Int
  ) {
    createDocumentType(
      input: {
        documentType: {
          name: $documentType
          companyId: $companyId
          lifetime: $lifetime
          autoDeleteDays: $autoDeleteDays
        }
      }
    ) {
      documentType {
        id
        name
        localizedName
        lifetime
      }
    }
  }
`)

export const DOCUMENT_TYPE_UPDATE = graphql(`
  mutation documentTypeUpdate(
    $id: UUID!
    $documentType: String!
    $lifetime: Int
    $autoDeleteDays: Int
  ) {
    updateDocumentTypeById(
      input: {
        id: $id
        patch: {
          name: $documentType
          lifetime: $lifetime
          autoDeleteDays: $autoDeleteDays
        }
      }
    ) {
      documentType {
        id
        name
        localizedName
        lifetime
        autoDeleteDays
      }
    }
  }
`)

export const DOCUMENT_TYPE_DELETE = graphql(`
  mutation documentTypeDelete($id: UUID!) {
    updateDocumentTypeById(input: { id: $id, patch: { active: false } }) {
      documentType {
        id
      }
    }
  }
`)

export const FILE_UPLOAD = graphql(`
  mutation fileUpload(
    $id: UUID
    $filename: String
    $mimetype: String
    $fileAccess: String
    $fileType: String
    $fileOwner: StorageFileOwner
    $fileOwnerId: UUID
    $documentTypeId: UUID
    $documentFolderId: UUID
    $base64: String
    $path: String
    $userIds: [UUID]
    $departmentIds: [UUID]
    $expireAt: Datetime
    $remindAt: Datetime
    $documentTemplateId: UUID
    $placeholderValues: JSON
    $sendNotification: Boolean
    $processTypeId: UUID
  ) {
    FileUpload(
      input: {
        id: $id
        filename: $filename
        mimetype: $mimetype
        fileAccess: $fileAccess
        fileType: $fileType
        fileOwner: $fileOwner
        fileOwnerId: $fileOwnerId
        documentTypeId: $documentTypeId
        documentFolderId: $documentFolderId
        base64: $base64
        path: $path
        userIds: $userIds
        departmentIds: $departmentIds
        expireAt: $expireAt
        remindAt: $remindAt
        documentTemplateId: $documentTemplateId
        placeholderValues: $placeholderValues
        sendNotification: $sendNotification
        processTypeId: $processTypeId
      }
    ) {
      id
      filename
      path
      base64
    }
  }
`)

export const FILE_DELETE = graphql(`
  mutation fileDelete($id: UUID!) {
    FileDelete(input: { id: $id }) {
      id
      filename
    }
  }
`)

export const FILE_DOWNLOAD = graphql(`
  mutation fileDownload($id: UUID!, $convertToPdf: Boolean) {
    FileDownload(input: { id: $id, convertToPdf: $convertToPdf }) {
      id
      filename
      mimetype
      path
      fileType
      fileOwner
      fileOwnerId
      documentTypeId
      fileExtension
      base64
    }
  }
`)

export const GENERATE_PDF = graphql(`
  mutation GeneratePDF($base64: String!) {
    GeneratePDF(input: { base64: $base64 }) {
      pdf
    }
  }
`)

export const PROCESS_BULK_UPLOAD_DOCUMENTS = graphql(`
  mutation processBulkUploadDocuments(
    $fileName: String!
    $documentTypeId: UUID
    $doCreateMissingFolders: Boolean!
    $inferDocumentTypeFromFileName: Boolean!
  ) {
    processBulkUploadDocuments(
      input: {
        fileName: $fileName
        documentTypeId: $documentTypeId
        doCreateMissingFolders: $doCreateMissingFolders
        inferDocumentTypeFromFileName: $inferDocumentTypeFromFileName
      }
    )
  }
`)
export const GET_PRESIGNED_UPLOAD_URL = graphql(`
  mutation getPresignedUploadLink($filename: String!) {
    getPresignedUploadLink(input: { filename: $filename }) {
      url
    }
  }
`)

export const DOWNLOAD_BULK_UPLOAD_TEMPLATE = graphql(`
  mutation downloadBulkDocumentTemplate {
    downloadBulkDocumentTemplate {
      base64
    }
  }
`)
